import { brandColor, brandInitial } from "../lib/format";
import type { Location } from "../lib/types";

export function BrandChip({ loc }: { loc: Location }) {
  return (
    <div
      className="brand-chip"
      style={{ background: brandColor(loc) }}
      aria-hidden
    >
      {brandInitial(loc)}
    </div>
  );
}
